module.exports = __webpack_public_path__ + "img/1w.8d9d170b.svg";